/* eslint-disable @typescript-eslint/naming-convention */
import type { IService } from '../../shared';
import { EventGenerator } from '../events';
import type { ServiceManager } from '../service-manager';

export class ShineService implements IService {
    /** 闪烁时长 */
    private __duration: number;

    constructor(readonly service: ServiceManager) {
        new EventGenerator('shine', this, service);
        this.__duration = 1200 * 3;
    }

    onInit() {
        this.setShineMap(new Set());
    }

    /** 图层闪烁 */
    readonly shineMap: Set<string> = new Set();
    declare getShineMap: () => Set<string>;
    declare setShineMap: (shineMap: Set<string>) => void;
    declare onShineMapChange: (fn: (shineMap: Set<string>) => void) => number;

    check(layerId: string) {
        return !!this.shineMap.has(layerId);
    }

    add(layerId: string, duration?: number) {
        if (this.check(layerId)) return;
        this.setShineMap(new Set([...this.shineMap, layerId]));
        setTimeout(() => {
            this.remove(layerId);
        }, duration || this.__duration);
    }

    remove(layerId: string) {
        if (!this.check(layerId)) return;
        this.shineMap.delete(layerId);
        this.setShineMap(new Set([...this.shineMap]));
    }
}
